import React, { useEffect, useState } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import { ArrowLeftIcon } from '@assets/icons/arrowLeftIcon';
import { ArrowRightIcon } from '@assets/icons/arrowRightIcon';

const Swipeable:React.FC<IProps> = (props) => {

  const [currentIndex, setCurrentIndex] = useState(0);

  const moveBackward = () => {
    movingEngine("backward");
  }

  const moveForeward = () => {
    movingEngine("foreward");
  }

  const movingEngine = (option: string) => {
    var index = currentIndex;        
    var swipeableBox = document.getElementById("swipeable-box")
    if (swipeableBox !== null) {
      var delta = Math.floor((swipeableBox.offsetWidth + 15)/props.itemWidth);
      if (option === "foreward") {
        if (index + delta > props.itemsLength - 1) index = props.itemsLength - delta;
        else index += delta;
      } else {
        if (index - delta < 0) index = 0;
        else index -= delta;
      }      
      setCurrentIndex(index);      
      var toScroll = document.getElementById(`preview-component-${index}${props.id ? `-${props.id}` : ``}`);
      if (toScroll !== null && toScroll.parentNode !== null) {
        toScroll.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: props.centerItem ? 'center' : 'start'});
      }
    }
  }

  const showStartArrow = ()=>{
    return currentIndex>0;
  }

  const showEndArrow = ()=>{
    if ((props.itemsCount??0)>0 && (props.itemsShow??0)>0)
    {
        if ((props.itemsCount??0)>(props.itemsShow??0))
        {
          return currentIndex< ((props.itemsCount??0)-1) 
        }
        else
          return false;
    }
    return true;    
  }

  return (
    <S.Root
      heightValue={props.height ? `${props.height}px` : 'auto'}
    >
      {
        showStartArrow() &&
        <S.ArrowLeftContainer
        onClick={moveBackward}
        topValue={`${props.topArrows ? props.topArrows : 0}px`}     
        smallArrows={props.smallArrows}   
        >
          <S.ArrowScale smallArrows={props.smallArrows}>
            <ArrowLeftIcon fillColor="#204078" />
          </S.ArrowScale>
        </S.ArrowLeftContainer>
      }
      <S.Swipeable
        id="swipeable-box"
      >
        {props.children}
      </S.Swipeable>
      {
        showEndArrow() &&
        <S.ArrowRightContainer
          onClick={moveForeward}
          topValue={`${props.topArrows ? props.topArrows : 0}px`}
          smallArrows={props.smallArrows}   
        >
          <S.ArrowScale smallArrows={props.smallArrows}>
            <ArrowRightIcon fillColor="#204078" />
          </S.ArrowScale>
        </S.ArrowRightContainer>
    }
    </S.Root>
  );
}

export default Swipeable;